import React from 'react';
import ListCard from './ListCard';
import useSaasPlatformStore from '../../../../../stores/saasPlatformStore';
import useCustomerStore from '../../../../../stores/customerStore';
var QuotePolicyItem = function (_a) {
    var _b, _c;
    var item = _a.item, handleStartQuote = _a.handleStartQuote;
    var _d = useCustomerStore(), extCustomerID = _d.extCustomerID, applicationFormData = _d.applicationFormData;
    var brokerFormLink = useSaasPlatformStore().brokerFormLink;
    var isPolicy = !!item.policy;
    var headingToDisplay;
    var idToDisplay;
    var identifier;
    var currentStatus;
    var horseData;
    var horsesPartnerDataMapper = function (payload, type) {
        var _a, _b, _c, _d, _e;
        if (type === void 0) { type = 'Quote'; }
        var horsesDetailsToExtract = [
            'HorsePassportName',
            'HorseSex',
            'HorseDOB',
        ];
        var finalPayload = payload;
        if (type === 'Policy' &&
            Array.isArray(payload === null || payload === void 0 ? void 0 : payload.mta) &&
            payload.mta.length > 0) {
            var sorted = payload.mta
                .slice()
                .sort(function (a, b) {
                return new Date(b.creationDateTimeUtc).getTime() -
                    new Date(a.creationDateTimeUtc).getTime();
            });
            var firstMta = sorted[0];
            var mtaHorsesLength = Number((_c = (_b = (_a = firstMta === null || firstMta === void 0 ? void 0 : firstMta.responses) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
                var id = _a.id;
                return id === 'HorseRepeatingElement.Length';
            })) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 0);
            if (mtaHorsesLength > 0) {
                finalPayload = firstMta;
            }
        }
        var horseRepeatinglength = Number((_e = (_d = finalPayload === null || finalPayload === void 0 ? void 0 : finalPayload.responses) === null || _d === void 0 ? void 0 : _d.find(function (_a) {
            var id = _a.id;
            return id == 'HorseRepeatingElement.Length';
        })) === null || _e === void 0 ? void 0 : _e.value);
        if (horseRepeatinglength == 0)
            return null;
        var mappedHorseData = {};
        var _loop_1 = function (index) {
            horsesDetailsToExtract.forEach(function (detail) {
                var _a;
                var _b;
                var answer = (_b = finalPayload.responses.find(function (_a) {
                    var id = _a.id;
                    return id == "HorseRepeatingElement[".concat(index, "].").concat(detail);
                })) === null || _b === void 0 ? void 0 : _b.value;
                if (mappedHorseData[index])
                    mappedHorseData[index][detail] = String(answer);
                else {
                    mappedHorseData[index] = (_a = {},
                        _a[detail] = String(answer),
                        _a);
                }
            });
        };
        for (var index = 0; index < horseRepeatinglength; index++) {
            _loop_1(index);
        }
        return Object.values(mappedHorseData);
    };
    if (!item.partnerData) {
        idToDisplay = item.externalId;
        headingToDisplay = 'Application ID';
        identifier = 'application';
        currentStatus = 'start';
        horseData = item.items;
    }
    else if (!isPolicy && item.partnerData) {
        idToDisplay = (_c = (_b = item.partnerData.quoteDetails) === null || _b === void 0 ? void 0 : _b.QuoteNumber) !== null && _c !== void 0 ? _c : '--';
        headingToDisplay = 'Quote ID';
        identifier = 'quote';
        currentStatus = item.status;
        horseData = horsesPartnerDataMapper(item.partnerData);
    }
    else {
        idToDisplay = String(item.policy.partnerData.policyId);
        headingToDisplay = 'Policy ID';
        identifier = 'policy';
        currentStatus = item.policy.insuranceStatus;
        horseData = horsesPartnerDataMapper(item.policy.partnerData, 'Policy');
    }
    // quote state pending (partner data not avaiable) display application id which is quote external ID
    // if partner data becomes avaiable show wtw id same for quote and same for policy
    // const generateDynamicLink = (status: string) => {
    //   const baseUrl = new URL(brokerFormLink || '');
    //   baseUrl.searchParams.set('extCustomerID', extCustomerID!);
    //   if (status === 'complete') {
    //     baseUrl.searchParams.set('savedQuote', idToDisplay);
    //   } else if (status === 'active') {
    //     baseUrl.searchParams.set('yourPolicies', idToDisplay);
    //   } else if (status === 'pending') {
    //     baseUrl.pathname = '/salesv2/quote/saved-quotes';
    //     baseUrl.searchParams.delete('sname');
    //   }
    //   return baseUrl.toString();
    // };
    // const handleClick = (status) => {
    //   const url = generateDynamicLink(status);
    //   window.open(url, '_blank');
    // };
    var handleClick = function (identifier) {
        var _a, _b;
        if (identifier === 'application') {
            if (!applicationFormData)
                return;
            var applicationDetails = (_a = applicationFormData[item.externalId]) === null || _a === void 0 ? void 0 : _a.applicationDetails;
            var productId = (_b = applicationFormData[item.externalId]) === null || _b === void 0 ? void 0 : _b.productId;
            handleStartQuote({
                requiredParams: item.items.requiredParams,
                // applicationDetails && Object.keys(applicationDetails).length > 0
                //   ? applicationDetails
                //   : item.items.requiredParams,
                optionalParams: {}
            }, item.ProductId, item.externalId);
        }
        else {
            var baseUrl = new URL(brokerFormLink || '');
            baseUrl.searchParams.set('extCustomerID', extCustomerID);
            if (identifier === 'quote') {
                baseUrl.searchParams.set('savedQuote', '1');
            }
            else if (identifier === 'policy') {
                baseUrl.searchParams.set('yourPolicies', '1');
            }
            window.open(baseUrl.toString(), '_blank');
        }
    };
    var DISABLE_DURATION_MS = 60 * 30 * 1000;
    var hasDurationPassed = function (createdAt) {
        var createdDate = new Date(createdAt);
        var deadline = new Date(createdDate.getTime() + DISABLE_DURATION_MS);
        return Date.now() >= deadline.getTime();
    };
    var isButtonDisabled = item.status === 'pending' && !hasDurationPassed(item.createdAt);
    var displayChip = identifier === 'application' && !isButtonDisabled;
    return (React.createElement(ListCard, { headingToDisplay: headingToDisplay, idToDisplay: idToDisplay, currentStatus: currentStatus, horseData: horseData, handleClick: function () { return handleClick(identifier); }, displayChip: displayChip, isButtonDisabled: isButtonDisabled }));
};
export default QuotePolicyItem;
